/**
 * ComboHud — extracted from GameCanvas.jsx.
 *
 * Top-center overlay shown when comboCount ≥ 3 (the threshold where
 * the score multiplier kicks in). Colour tier changes by combo size:
 *
 *   3-4    → cyan   (1.5× implicit)
 *   5-9    → violet (×2)
 *   10-24  → pink   (×3)
 *   25+    → gold   (×5)
 *
 * `key={comboCount}` on the parent <div> in GameCanvas is the trick
 * that retriggers the `combo-pop` animation on every chain increment;
 * we preserve that behavior by keeping the same DOM shape.
 */
function tier(combo) {
  if (combo >= 25) return { color: "#ffd700", glow: "rgba(255,215,0,0.55)", mult: "×5" };
  if (combo >= 10) return { color: "#ff007f", glow: "rgba(255,0,127,0.55)", mult: "×3" };
  if (combo >= 5) return { color: "#b026ff", glow: "rgba(176,38,255,0.55)", mult: "×2" };
  return { color: "#00ffff", glow: "rgba(0,255,255,0.45)", mult: null };
}

export default function ComboHud({ comboCount }) {
  if (comboCount < 3) return null;
  const { color, glow, mult } = tier(comboCount);
  return (
    <div
      className="absolute left-1/2 -translate-x-1/2 top-2 sm:top-4 pointer-events-none z-20 combo-pop"
      data-testid="combo-hud"
      key={`combo-${comboCount}`}
    >
      <div
        className="px-3 py-1 sm:px-4 sm:py-1.5 border bg-black/55 backdrop-blur-sm flex items-center gap-2"
        style={{
          borderColor: color,
          boxShadow: `0 0 22px ${glow}`,
        }}
      >
        <span
          className="font-mono-cosmic uppercase tracking-[0.25em] text-[9px] sm:text-[10px]"
          style={{ color }}
        >
          COMBO
        </span>
        <span
          className="font-heading text-2xl sm:text-3xl tabular-nums leading-none"
          style={{ color: "#fff", textShadow: `0 0 10px ${color}` }}
          data-testid="combo-count"
        >
          ×{comboCount}
        </span>
        {mult && (
          <span
            className="font-mono-cosmic text-[9px] sm:text-[10px] tracking-[0.2em] tabular-nums"
            style={{ color }}
            data-testid="combo-mult"
          >
            {mult}
          </span>
        )}
      </div>
    </div>
  );
}
